import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@livable/saas-react-components';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, FormGroup, FormControlLabel, Checkbox, Typography, Alert } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useStyles from './styles';
const Gwd = observer(_ref => {
  let formik = _ref.formik,
    handleClose = _ref.handleClose,
    initialGWD = _ref.initialGWD,
    propertyId = _ref.propertyId,
    cadValue = _ref.cadValue;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Apply Billing';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const applyBill = currentCompany.billingTab.applyBill || {};
  const setApplyBillAutosave = currentCompany.billingTab.setApplyBillAutosave;
  const utilityToSave = store.properties.propertyUtilities.find(u => u.utilityId === applyBill.utilityId);
  const gwdHistory = store.propertyUtility.historyByPropertyUtilityId.get(utilityToSave.propertyUtilityId);
  const _useState = useState(initialGWD),
    _useState2 = _slicedToArray(_useState, 2),
    goodWillDeduction = _useState2[0],
    setGwd = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    goodWillDeductionUpdateComment = _useState4[0],
    setGoodWillDeductionUpdateComment = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isChecked = _useState6[0],
    setIsChecked = _useState6[1];
  const getGwdHistory = async data => {
    const resp = await store.propertyUtility.getGwdHistoryAsync.run(data);
    return resp;
  };
  const getPropertyUtilityProviders = async data => {
    const resp = await store.properties.getPropertyUtilityProvidersV3Async.run(data);
    return resp;
  };
  const updateNewPropertyUtilityConfigBatch = async () => {
    const data = _objectSpread(_objectSpread({}, utilityToSave), {}, {
      customCommonAreaDeduction: utilityToSave.commonAreaDeduction,
      goodWillDeduction,
      goodWillDeductionUpdateComment
    });
    if (isChecked) data.applyOnAllocationCycleId = applyBill.allocationCycleId;
    const resp = await store.propertyUtility.updatePropertyUtilityAsync.run({
      propertyUtilityId: utilityToSave.propertyUtilityId,
      propertyUtilities: _objectSpread({}, data)
    });
    return resp;
  };
  useEffect(() => {
    if (!gwdHistory) getGwdHistory({
      propertyUtilityId: utilityToSave.propertyUtilityId
    }).then(resp => {
      var _resp$response;
      const ids = ((_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.map(c => c.updatedByUserAccountId).filter(id => id)) || [];
      const accountIds = [...new Set([...ids])];
      return store.account.getUsersProfilesAsync.run({
        accountIds
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utilityToSave.propertyUtilityId]);
  const handleSave = async () => {
    track(events.clicked('Save GWD'), {
      page,
      goodWillDeduction,
      isAppliedOnCycleOnly: isChecked,
      utility: applyBill.utilityName
    });
    await updateNewPropertyUtilityConfigBatch().then(() => getPropertyUtilityProviders({
      propertyId
    })).then(() => {
      currentCompany === null || currentCompany === void 0 || currentCompany.billingTab.setApplyBill(_objectSpread(_objectSpread({}, applyBill), {}, {
        goodWillDeduction: goodWillDeduction
      }));
      formik.setFieldValue('goodWillDeduction', goodWillDeduction);
      handleClose();
      setApplyBillAutosave(true);
      setTimeout(() => setApplyBillAutosave(false), 2000);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxHeader
  }, /*#__PURE__*/React.createElement("span", null, "Change Good Will Deduction (GWD)"), /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      track(events.clicked('Close GWD'), {
        page,
        utility: applyBill.utilityName
      });
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxFormValue
  }, /*#__PURE__*/React.createElement(FormControl, {
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setGwd(e.target.value * 1);
    },
    variant: "outlined",
    fullWidth: true,
    error: +cadValue + +goodWillDeduction > 100
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "goodWillDeduction"
  }, 'GWD'), /*#__PURE__*/React.createElement(OutlinedInput, {
    error: +cadValue + +goodWillDeduction > 100,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "%"),
    fullWidth: true,
    label: 'Bill value',
    id: "goodWillDeduction",
    name: "goodWillDeduction",
    onBlur: e => {
      if (e.target.value !== '') track(events.filled('GWD'), {
        page,
        value: e.target.value
      });
    },
    type: "text",
    value: goodWillDeduction
  }))), +cadValue + +goodWillDeduction > 100 && /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "The total of CAD and GWD cannot exceed 100%. We recommend the maximum allowable value for GWD is", ' ', 100 - cadValue, "%. Please adjust your input.")), +cadValue + +goodWillDeduction === 0 && /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Both CAD and GWD cannot be zero.", /*#__PURE__*/React.createElement("br", null), "We recommend to assign a positive value to at least one of them.")), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxFormInfo
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "info"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "GWD exists to offset unreported occupancy changes and industry best practices are the keep it at roughly 5%")), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxFormItem
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('Comment'),
    onBlur: e => {
      if (e.target.value) track(events.filled('GWD Comment'), {
        page
      });
    },
    onChange: e => setGoodWillDeductionUpdateComment(e.target.value),
    value: goodWillDeductionUpdateComment,
    variant: "outlined"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxFormItem
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      onChange: () => {
        track(!isChecked ? events.enabled('Use GWD Once') : events.disabled('Use GWD Once'), {
          page
        });
        setIsChecked(!isChecked);
      },
      value: isChecked
    }),
    label: 'Use this GWD just this time'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxFormActions
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      track(events.clicked('Discard GWD'), {
        page,
        utility: applyBill.utilityName
      });
      handleClose();
    },
    size: "small",
    variant: "text",
    'custom-attribute': '611-new-billing-module'
  }, "Discard"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    size: "small",
    disabled: +cadValue + +goodWillDeduction > 100,
    variant: "contained",
    'custom-attribute': '612-new-billing-module'
  }, "Save"))), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxList
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxListTitle
  }, "GWD history:"), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxListItems
  }, gwdHistory === null || gwdHistory === void 0 ? void 0 : gwdHistory.map(i => /*#__PURE__*/React.createElement("div", {
    key: i.id,
    className: classes.gwdBoxListItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxListItemTitle
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", null, moment(i.createdOn).format('MM/DD/YY')), " by", ' ', store.account.profilesFullName.get(i.updatedByUserAccountId) || 'N/A'), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxValue
  }, /*#__PURE__*/React.createElement("b", null, "GWD: ", i.goodWillDeduction, "%"), i.applyOnAllocationCycleId ? /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxListItemBody
  }, "Applied only for this cycle") : '')), /*#__PURE__*/React.createElement("div", {
    className: classes.gwdBoxListItemBody
  }, /*#__PURE__*/React.createElement("span", null, "Comment:"), " ", i.updateComment))))));
});
export default Gwd;